import * as yup from 'yup';
import { validationMessagesTranslation } from '../translation';

yup.setLocale(validationMessagesTranslation);

/**
 * Validate fields based on passed schema
 * @param {yup.any} schema Base schema
 * @param {Json} value Value object to validate
 * @param {String} reachField Option to validate only a specific schema field
 */
export default async function validate(baseSchema, valuesToCompair, fieldsToReach = []) {
  if (fieldsToReach.length) {
    const getValue = (object, keys) => keys.split('.').reduce((o, k) => (o || {})[k], object);

    return Promise.all(fieldsToReach.map(async (field) => {
      await yup.reach(baseSchema, field).validate(getValue(valuesToCompair, field))
        .catch((e) => {
          throw Object({
            ...e,
            path: field,
            message: e.message.replace('this', field),
          });
        });
    }));
  }

  return baseSchema.validate(valuesToCompair);
}

export const whatsappSchema = yup.string().trim().required().matches(/^[0-9]+$/, 'Deve conter apenas números')
  .length(11);
export const nameSchema = yup.string().required().min(3);

export const emailSchema = yup.string().email('Insira um email válido').required()

export const passwordSchema = yup.string().min(6).max(24);

export const nicknameSchema = yup.string().required().min(3).matches(/^[a-zA-Z0-9-_.]+$/, 'Apelido pode conter apenas letras, números, ponto e underline');